import {Address, Gender} from "./user";

export interface Option {
    key: string;
    value: string;
}


export interface SignPostDTO{
    email: string,
    codePhone: string,
    phoneNumber: string,
    name: string,
    birthday: string,
    gender: Gender,
    address: Address,
    code: string,
    nationality: string,
    isAgreementEmailMarketingReceipt: boolean,
    isAgreementSMSMarketingReceipt: boolean,
    isAgreementPersonalInfoCollectionAndUsage: boolean
}

export interface ValidateSignupRequestDTO{
    signupSteps: SignupSteps,
    email: string;
    codePhone?: string,
    phoneNumber?: string,
    name?: string,
    birthday?: string,
    gender?: string,
    address?: Address,
    nationality?: string,
}

export interface SignResponse{
    accessToken: string;
    refreshToken: string;
    tokenType: string
}

export interface LeavePostDTO{
    reason: string;
}

export enum SignupSteps{
    STEP1 = "STEP1",
    STEP2 = "STEP2",
}